import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKikComponent } from './simple-icons-kik.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKikComponent ],
    exports:      [ SimpleIconsKikComponent ],
    bootstrap:    []
})
export class SimpleIconsKikModule {}
